import { addToGlobalThisRet } from "@plugins";

function setLabelsWrapGridTemplate() {
    const filterRadioBoxWraps = document.querySelectorAll(".filter-radio__box");

    if (filterRadioBoxWraps) {
        filterRadioBoxWraps.forEach((item) => {
            const labels = Array.from(item.children);
            let labelWidth = 0;

            labels.forEach((label) => {
                if (label.offsetWidth > labelWidth) {
                    labelWidth = label.offsetWidth;
                }
            });

            if (labelWidth > 130) {
                labels.forEach((label) => {
                    label.style.gridColumn = "span 2";
                });
            }
        });
    }
}

if (!window.mobileMedia) {
    window.addEventListener("load", () => setLabelsWrapGridTemplate());
}

addToGlobalThisRet(setLabelsWrapGridTemplate, "setLabelsWrapGridTemplate");
